import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useAuthUser,
  useCurrentCompany,
} from '@employ-engage/common-components';
import FindCompanyForm from '../find-company-form/find-company-form';

/* eslint-disable-next-line */
export interface HomeProps {}

export function Home(props: HomeProps) {
  const { t } = useTranslation(['common']);
  const { currentCompany } = useCurrentCompany();
  const { user } = useAuthUser();

  return (
    <div>
      <div className="flex justify-center mt-20">
        {user && currentCompany ? (
          <Link
            data-testid="begin-button"
            to={`/${currentCompany.friendlyCompanyId}/form`}
            className="bg-light-primary hover:bg-light-primaryAccent dark:bg-dark-primary dark:hover:bg-dark-primaryAccent text-white dark:text-custom-gray600 text-center text-lg sm:text-4xl font-bold py-4 px-8 rounded-xl"
          >
            {t(`Begin`)}
          </Link>
        ) : (
          <FindCompanyForm />
        )}
      </div>
    </div>
  );
}

export default Home;
